// Only fields the UI shows or edits. There is no tenantId: the API derives the
// tenant from the caller and the client never names one.
const PRODUCT_FIELDS = `
    id
    name
    summary
    description
    eulaUrl
    supportContact
    status
    pricingSource
    billingLink {
        productId
        catalogVersion
    }
    dimensions {
        dimensionId
        name
        description
        unit
        kind
        usageSource {
            source
            meterId
        }
        prices {
            term
            amount
            currency
        }
    }
    version
    created
    updated
`;

export const PRODUCT_SELECTION = PRODUCT_FIELDS;

// listProducts takes (limit, nextToken) only. There is no filter and no sort
// argument; sending either fails validation of the whole document.
export const listProducts = `
   query listProducts($limit: Int, $nextToken: String) {
       listProducts(limit: $limit, nextToken: $nextToken) {
           items {${PRODUCT_FIELDS}}
           nextToken
       }
   }
`;

export const getProduct = `
   query getProduct($id: ID!) {
       getProduct(id: $id) {${PRODUCT_FIELDS}}
   }
`;
